import { useRouteLoaderData } from '@remix-run/react';

import type { RootLoaderData } from '~/root';

const useIsLoggedIn = () => {
  const root = useRouteLoaderData<RootLoaderData>('root');

  return root?.isLoggedIn ?? false;
};

export default useIsLoggedIn;
